import styled from 'styled-components'

import TopBannerLeftImage from '../../../assets/REDESIGN_Assets/Landing/TopBarLeftImage.png'
import TopBannerRightImage from '../../../assets/REDESIGN_Assets/Landing/TopBarRightImage.jpg'
import StarSvg from '../../../assets/REDESIGN_Assets/Landing/star-icon.svg'
import LandingArrowRight from '../../../assets/REDESIGN_Assets/Landing/landing-arrow-right.svg'
import LandingArrowLeft from '../../../assets/REDESIGN_Assets/Landing/landing-arrow-left.svg'
import PlatformsImage from '../../../assets/REDESIGN_Assets/Landing/platforms-image.png'
import PlayButtonImage from '../../../assets/REDESIGN_Assets/Landing/play-button-image.svg'
import FitmatkaJoinImage from '../../../assets/REDESIGN_Assets/Landing/FitmatkaJoinImage.png'
import FooterArrowIcon from '../../../assets/REDESIGN_Assets/Landing/footer-arrow-icon.svg'

import przemiana1left from '../../../assets/REDESIGN_Assets/Landing/przemiana1_left.jpeg'
import przemiana2left from '../../../assets/REDESIGN_Assets/Landing/przemiana2_left.jpeg'
import przemiana3left from '../../../assets/REDESIGN_Assets/Landing/przemiana3_left.jpeg'
import przemiana4left from '../../../assets/REDESIGN_Assets/Landing/przemiana4_left.jpeg'
import przemiana5left from '../../../assets/REDESIGN_Assets/Landing/przemiana5_left.jpeg'
import przemiana6left from '../../../assets/REDESIGN_Assets/Landing/przemiana6_left.jpeg'

import przemiana1right from '../../../assets/REDESIGN_Assets/Landing/przemiana1_right.jpeg'
import przemiana2right from '../../../assets/REDESIGN_Assets/Landing/przemiana2_right.jpeg'
import przemiana3right from '../../../assets/REDESIGN_Assets/Landing/przemiana3_right.jpeg'
import przemiana4right from '../../../assets/REDESIGN_Assets/Landing/przemiana4_right.jpeg'
import przemiana5right from '../../../assets/REDESIGN_Assets/Landing/przemiana5_right.jpeg'
import przemiana6right from '../../../assets/REDESIGN_Assets/Landing/przemiana6_right.jpeg'

export const TopBannerImage = styled.div`
  width: 100%;
  height: 75vh;

  video {
    height: 100%;
    object-fit: cover;
    width: 100%;
    top: -2px;
    position: relative;
    height: 101%;
  }

  @media screen and (max-width: 400px) {
    &.ios {
      height: 70vh;
    }
  }

  &.right-image {
    /* background: url(${TopBannerRightImage});
    background-size: cover;
    background-position: center;
    background-position-y: 30%;

    width: 50%; */
    /* width: 100vw; */

    /* background-repeat: no-repeat; */

    @media screen and (max-width: 600px) {
      width: 100%;
    }
  }
  &.left-image {
    /* display: none; */
    transition: all 0.07s ease-in-out;
    overflow: hidden;
    background: url(${TopBannerLeftImage});
    background-size: cover;
    /* background-position: center; */
    background-position-y: 30%;
    background-repeat: no-repeat;
  }

  @media screen and (max-width: 600px) {
    width: 100%;
  }
`

export const TopBannerFadeOut = styled.div`
  height: 50%;
  width: 100%;
  background: rgb(52, 33, 82);
  background: linear-gradient(
    0deg,
    rgba(52, 33, 82, 0.7998774509803921) 0%,
    rgba(52, 33, 82, 0.52379901960784315) 60%,
    rgba(52, 33, 82, 0) 100%
  );
  position: absolute;
  bottom: 0;
  z-index: 1;
`

export const SectionContainer = styled.section`
  padding: 0 15%;
  margin: ${(props) => (props.margin ? props.margin : 'unset')};
  width: 100%;
  box-sizing: border-box;
  position: relative;

  &.join-miazga-section {
    @media screen and (max-width: 1024px) {
      padding: 0px 10%;
    }
    @media screen and (max-width: 600px) {
      padding: 0 4%;
    }
  }

  &.video-section {
    @media screen and (max-width: 1024px) {
      padding: 0px 10%;
    }

    @media screen and (max-width: 600px) {
      padding: 0 4%;
    }
  }

  &.platforms {
    height: 50vh;

    padding: 0 20%;

    @media screen and (max-width: 1024px) {
      height: 35vh;
      padding: 0px 10%;
    }

    @media screen and (max-width: 600px) {
      height: 65vh;
      padding: 0px 10%;
    }

    @media screen and (max-width: 380px) {
      height: 65vh;
      padding: 0px 10%;
    }

    &.isTablet {
      @media screen and (orientation: portrait) {
        height: 30vh;
      }

      @media screen and (orientation: landscape) {
        height: 50vh;
      }
    }
  }

  &.transformation {
    @media screen and (max-width: 1024px) {
      padding: 0px 10%;
    }
    @media screen and (max-width: 600px) {
      padding: 0 4%;
    }
  }

  &.still-here {
    position: relative;
    /* height: 3vh; */
    height: 55vh;
    min-height: 350px;
    max-height: 600px;

    @media screen and (max-width: 1024px) {
      height: 35vh;
      padding: 0px 10%;
    }
    @media screen and (max-width: 600px) {
      padding: 0 4%;
    }
  }
`

export const StarImage = styled.div`
  width: 3.6vw;
  height: 3vw;
  background: url(${(props) => props.src});
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;

  @media screen and (max-width: 1024px) {
    width: 10vw;
    height: 7vw;
  }

  @media screen and (max-width: 600px) {
    width: 25vw;
    height: 20vw;
  }
`

export const TransformationImageContainer = styled.div`
  width: 15vw;
  height: 40vh;

  border-radius: 30px;
  position: relative;

  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  transition: all 0.3s ease-in-out;

  @media screen and (max-width: 1024px) {
    height: 50vh;
    width: 30vw;
    margin: 5px 0;
  }

  @media screen and (max-width: 600px) {
    height: 50vh;
    width: 75vw;
    margin: 5px 0;
  }

  &.left {
    background: url('${(props) =>
      props.activeImage && props.activeImage == 1
        ? przemiana1left
        : props.activeImage == 2
        ? przemiana2left
        : props.activeImage == 3
        ? przemiana3left
        : props.activeImage == 4
        ? przemiana4left
        : props.activeImage == 5
        ? przemiana5left
        : props.activeImage == 6
        ? przemiana6left
        : 'unset'}');
    background-size: cover;
    background-repeat: no-repeat;
  }

  &.right {
    background: url('${(props) =>
      props.activeImage && props.activeImage == 1
        ? przemiana1right
        : props.activeImage == 2
        ? przemiana2right
        : props.activeImage == 3
        ? przemiana3right
        : props.activeImage == 4
        ? przemiana4right
        : props.activeImage == 5
        ? przemiana5right
        : props.activeImage == 6
        ? przemiana6right
        : 'unset'}');
    background-size: cover;
    background-repeat: no-repeat;
  }

  &.after {
    &::after {
      content: 'Po';
      position: absolute;
      bottom: 0;
      height: 10%;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      font-family: 'Nunito';
      color: white;
      font-size: 1.3rem;
      font-weight: bold;
      border-bottom-left-radius: 30px;
      border-bottom-right-radius: 30px;
      background-color: #e39400;
      width: 100%;
    }
  }
  &.before {
    &::after {
      content: 'Przed';
      position: absolute;
      bottom: 0;
      height: 10%;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      font-family: 'Nunito';
      color: white;
      font-size: 1.3rem;
      font-weight: bold;
      border-bottom-left-radius: 30px;
      border-bottom-right-radius: 30px;
      background-color: #e39400;
      width: 100%;
    }
  }
`

export const TransformationImageButton = styled.button`
  height: 30px;
  width: 30px;
  border-radius: 50%;
  border: none;
  cursor: pointer;

  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;

  &.left {
    background-image: url(${LandingArrowLeft});
  }
  &.right {
    background-image: url(${LandingArrowRight});
  }

  @media screen and (max-width: 600px) {
    height: 30px;
    width: 30px;
  }
`

export const PlatformImage = styled.img`
  position: absolute;
  width: 55vw;
  top: 0;
  right: 14%;
  z-index: 0;

  @media (max-width: 600px) {
    top: 32vh;
    width: 100vw;
    left: 0;
  }

  &.isTablet {
    @media screen and (orientation: portrait) {
      top: 32%;
    }

    @media screen and (orientation: landscape) {
      top: 25%;
    }
  }

  /* @media screen and (max-width: 1024px){
  width: 100%;
    background-position-x: 0;
    background-position-y: 0;
    transform: scale(0.5, 0.85);

    top: -25vh;
    right: -17vw;
}

@media screen and (max-width: 768px){
  width: 100%;
    background-position-x: 0;
    background-position-y: 0;
    transform: scale(0.8);
    top: -22vh;
    right: -10vw;
}


@media (min-width:601px ) {
  position: absolute;
  background-size: 105% 80%;
  background-position-x: 7vh;
  background-position-y: 8vh;
} */

  /* @media screen and (max-width:768px){
  width: 75%;
  background-position-x: 9vh;
} */

  /* @media screen and  (max-width: 600px){
  height: 42vh;
  background-position-x: 0vh;
  width: 120%;
} */
`

export const VideoSectionVideo = styled.video`
  width: 100%;
  border-radius: 30px;

  &.app-video {
    object-fit: cover;
    max-width: 23vw;
    min-height: 55vh !important;

    &.isTablet {
      @media screen and (orientation: portrait) {
        max-width: 55vw;
      }

      @media screen and (orientation: landscape) {
        max-width: 31vw;
      }
    }

    @media screen and (max-width: 600px) {
      max-width: 100%;
      min-height: 70vh !important;
    }
  }
`

export const VideoPlayButton = styled.button`
  width: 5.5vw;
  height: 5.5vw;
  border-radius: 50%;
  border: none;
  cursor: pointer;
  position: absolute;
  background-color: transparent;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  background-image: url(${PlayButtonImage});

  @media screen and (max-width: 600px) {
    width: 15.5vw;
    height: 15.5vw;
    left: 38vw;
    top: 10vh;
  }

  &.join-miazga-section {
    @media screen and (max-width: 600px) {
      top: 30vh;
    }
  }
`

export const FitMatkaJoinMiazgaImage = styled.img`
  position: absolute;
  width: 28vw;
  height: auto;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  left: 0;
  bottom: 0vh;
  background-image: url(${FitmatkaJoinImage});

  @media screen and (max-width: 600px) {
    width: 38vw;
  }
`

export const FooterArrow = styled.button`
  width: 0.65vw;
  height: 0.65vw;
  border-radius: 50%;
  border: none;
  cursor: pointer;
  margin-left: 5px;
  background-color: transparent;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  background-image: url(${FooterArrowIcon});
`

export const LandingSocialContainer = styled.div`
  position: absolute;
  right: 5%;
  display: flex;

  @media (max-width: 600px) {
    flex-direction: column;
    right: 0%;
  }
`

export const LandingSocial = styled.div`
  border-radius: 50%;
  width: 2.5rem;
  height: 2.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  svg {
    fill: white;
    transition: all 0.3s ease-in-out;

    &:hover {
      transform: scale(1.2);
    }
  }

  &.fb {
    background-color: #395196;
    margin-right: 10px;

    @media (max-width: 600px) {
      margin-right: 10px;
      margin-bottom: 5px;
    }
  }

  &.insta {
    background: radial-gradient(
        circle farthest-corner at 35% 90%,
        #fec564,
        transparent 50%
      ),
      radial-gradient(
        circle farthest-corner at 0 140%,
        #fec564,
        transparent 50%
      ),
      radial-gradient(
        ellipse farthest-corner at 0 -25%,
        #5258cf,
        transparent 50%
      ),
      radial-gradient(
        ellipse farthest-corner at 20% -50%,
        #5258cf,
        transparent 50%
      ),
      radial-gradient(
        ellipse farthest-corner at 100% 0,
        #893dc2,
        transparent 50%
      ),
      radial-gradient(
        ellipse farthest-corner at 60% -20%,
        #893dc2,
        transparent 50%
      ),
      radial-gradient(
        ellipse farthest-corner at 100% 100%,
        #d9317a,
        transparent
      ),
      linear-gradient(
        #6559ca,
        #bc318f 30%,
        #e33f5f 50%,
        #f77638 70%,
        #fec66d 100%
      );
  }
`
